const TrafficStatusColorTag = {
  failov: '#7ECF42',
  fallb: '#E74C3C',
  waiting: '#A9A9A9',
};
const TrafficStatus = {
  replica: 'Traffic to Replica',
  original_server: 'Traffic to Original Server',
  unknown: 'Unknown',
  waiting: 'Waiting for Update',
};
const DayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
export { DayList, TrafficStatus, TrafficStatusColorTag };
